// removed by extract-text-webpack-plugin
module.exports = {"root":"h07xz","hero":"_11Q1c","heroContainer":"_2Ac_E","heroTitle":"RPGRV","heroPreamble":"_bRUG","spacer":"_2QsQD","search":"_22Dya","searchButton":"_1tedJ","searchInput":"_10c5q","boxes":"_2js7g","footer":"_2ru3O","uspIcon":"_1vxFK","blue":"MIwGe","orange":"_1mx36","green":"_1YhGJ","imageWrapper":"_3vfT0","boxImage":"_2a_eV","compactBox":"YSHkG","storyWrapper":"_2zj3g","link":"_3U4ht"};


//////////////////
// WEBPACK FOOTER
// ../source/views/Home/styles.css
// module id = 1645
// module chunks = 10